import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import { async } from 'q';
const { proxy } = require('../../ip_api.config')

class Flim_EditBomLine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            previewbom: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.push_arrItemSave()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    push_arrItemSave = () => {
        // console.log('id', this.state.id)
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/flim/get_bomline'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        db_name: val.db_name,
                        user: val.BOM_ApproverPersonnelNumber,
                        bom_no: val.BOM_BOMId,
                        bom_description: val.BOM_Name,
                        item_group: val.BOM_ItemGroupId,
                        line_no: val.LineNum,
                        item_no: val.ItemId,
                        item_description: val.ItemId_description,
                        amount: val.BOMQty,
                        unit: val.UnitId,
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => { this.getBom_Preview() })
            })
    }

    getBom_Preview = () => {
        let arr = []

        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    {
                        val.db_name === 'DPL' ?
                            <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                            : val.db_name === 'DFIX' ?
                                <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DPT' ?
                                    <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                    : <td></td>
                    }
                    <td>{val.user}</td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="bom_no" onBlur={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_no} />
                    </bs4.Col></td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="textarea" name="bom_description" onBlur={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_description} />
                    </bs4.Col></td>
                    <td>{this.state.arr_save[i].item_group}</td>
                    <td>{this.state.arr_save[i].line_no}</td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="item_no" onBlur={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.item_no} />
                    </bs4.Col></td>
                    <td>{this.state.arr_save[i].item_description}</td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="amount" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.amount} />
                    </bs4.Col></td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="unit" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.unit} />
                    </bs4.Col></td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    get_dataStandrad = async (itemG1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataStandrad'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("get_dataStandrad", responseJson.result[0])
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    selectDescriptionSM = (item) => new Promise(async (resolve, reject) => {
        let url = proxy.server + '/flim/selectDescriptionSM'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                item: item
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log('responseJson', responseJson)
                if (responseJson.status === 304) {
                    resolve('')
                } else {
                    resolve(responseJson.result[0].NAMEALIAS)
                }
            })
    })

    handleChangeItem = async (index, name, value) => {
        if (name === 'bom_no') {
            this.state.arr_save[index].bom_no = value

            let dataStandrad = await this.get_dataStandrad(value.substr(0, 3))
            this.state.arr_save[index].item_group = dataStandrad === undefined || dataStandrad.ItemGroupId === null ? '' : dataStandrad.ItemGroupId
        } else if (name === 'bom_description') {
            this.state.arr_save[index].bom_description = value
        } else if (name === 'item_no') {
            let _item_description = await this.selectDescriptionSM(value)

            this.state.arr_save[index].item_no = value
            this.state.arr_save[index].item_description = _item_description
        } else if (name === 'amount') {
            this.state.arr_save[index].amount = value
        } else if (name === 'unit') {
            this.state.arr_save[index].unit = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.getBom_Preview()
        })
    }

    update_bomline = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/update_bomline'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: this.state.id,
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Flim/PreviewBomLine'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_EditBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >EDIT BOM LINE</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_bomline()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th>ฐานข้อมูล</th>
                            <th>User</th>
                            <th>Bom No</th>
                            <th>bom description</th>
                            <th>Item Group</th>
                            <th>Line No</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Item No.</th>
                            <th>Item Description</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>จำนวน</th>
                            <th>หน่วยของสินค้า</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewbom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_EditBomLine